import { type Account, Auth } from '@air/api';

export type GetProviderNameFromSSOOptionsParams = Extract<
  Awaited<ReturnType<typeof Account.getAccountSSOOptionsV2>>,
  // biome-ignore lint/suspicious/noExplicitAny: <Data from SSO options can be anything>
  { data: any }
>['data'][number];

export const getProviderNameFromSSOOptions = (ssoOptions: GetProviderNameFromSSOOptionsParams) => {
  return 'organizationId' in ssoOptions
    ? Auth.convertOrganizationIdToSAMLProvider(ssoOptions.organizationId)
    : Auth.convertWorkspaceIdToSAMLProvider(ssoOptions.workspaceId);
};
